import {
  SET_JILI_GAME_NAMES,
  SET_JILI_GAME_IMAGES,
  SET_JILI_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  jiliNames: [],
  jiliImages: [],
  jiliPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_JILI_GAME_NAMES:
      return { ...state, jiliNames: action.payload }
    case SET_JILI_GAME_IMAGES:
      return { ...state, jiliImages: action.payload };
    case SET_JILI_GAME_POLA:
      return { ...state, jiliPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;